import React from 'react'
import Grid from '@mui/material/Grid'
import SimpleTextField from '../../../../../components/Forms/SimpleTextField'

const Temperature = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <SimpleTextField
      value={value}
      onChange={onChange}
      label="Temperature"
      type="number"
      InputProps={{
        inputProps: { min: 34, max: 44, step: 'any' },
        endAdornment: '°C',
      }}
      error={value !== '' && (value < 30 || value > 50)}
    />
  </Grid>
)

export default Temperature
